import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setCurrentScreen } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD-IRVwgbHNVQvqnp9fq92lLUnpzv6teU0",
  authDomain: "ae-clouds.firebaseapp.com",
  projectId: "ae-clouds",
  storageBucket: "ae-clouds.firebasestorage.app",
  messagingSenderId: "561842872955",
  appId: "1:561842872955:web:68f5d46eebfd22829878de",
  measurementId: "G-V6L1L1F6CK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and export it
export const analytics = getAnalytics(app);

// Helper functions for analytics
export const logAnalyticsEvent = (eventName: string, eventParams?: { [key: string]: any }) => {
  logEvent(analytics, eventName, eventParams);
};

export const setAnalyticsScreen = (screenName: string) => {
  setCurrentScreen(analytics, screenName);
};